var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DocWordIcon, DocPdfIcon, DocImageIcon, DocUrlIcon, DocExcelIcon, DocUnknownIcon, } from '../icons';
export function file2Obj(file) {
    return __assign(__assign({}, file), { lastModified: file.lastModified, lastModifiedDate: file.lastModifiedDate, name: file.name, size: file.size, type: file.type, uid: file.uid, percent: 0, originFileObj: file });
}
export function getFileItem(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter(function (item) { return item[matchKey] === file[matchKey]; })[0];
}
export function updateFileList(file, fileList) {
    var nextFileList = __spreadArray([], fileList, true);
    var fileIndex = nextFileList.findIndex(function (_a) {
        var uid = _a.uid;
        return uid === file.uid;
    });
    if (fileIndex === -1) {
        nextFileList.push(file);
    }
    else {
        nextFileList[fileIndex] = file;
    }
    return nextFileList;
}
export function removeFileItem(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    var removed = fileList.filter(function (item) { return item[matchKey] !== file[matchKey]; });
    if (removed.length === fileList.length) {
        return null;
    }
    return removed;
}
export var FileIcons = {
    'undefined': DocUnknownIcon,
    '.doc': DocWordIcon,
    '.docx': DocWordIcon,
    '.pdf': DocPdfIcon,
    '.png': DocImageIcon,
    '.jpg': DocImageIcon,
    '.jpeg': DocImageIcon,
    '.html': DocUrlIcon,
    '.excel': DocExcelIcon,
    '.xls': DocExcelIcon,
    '.xlsx': DocExcelIcon,
};
export var getFileFormat = function (fileName) {
    var index = fileName.lastIndexOf('.');
    var ext = fileName.substring(index).toLowerCase();
    return ext || '';
};
